import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FieldComponent} from './field/field.component';
import {EventNamePipe} from './event-name-pipe';
import {DeviationDescriptionPipe} from './deviation-description.pipe';
import {AttachmentListComponent} from './attachment-list/attachment-list.component';
import {AttachmentComponent} from './attachment/attachment.component';
import {SignatureComponent} from './signature/signature.component';
import {ErrorComponent} from './error/error.component';
import {LoadingDialogComponent} from './loading-dialog/loading-dialog.component';
import {ConfirmationDialogComponent} from './confirmation-dialog/confirmation-dialog.component';
import {FormsModule} from '@angular/forms';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {ButtonBoxComponent} from './button-box/button-box.component';
import {ExpandPanelComponent} from './expand-panel/expand-panel.component';
import {ListComponent} from './list/list.component';
import {PageContentComponent} from './page-content/page-content.component';
import {SearchFieldComponent} from './search-field/search-field.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import {SelectBoxComponent} from './select-box/select-box.component';
import {MatRippleModule} from '@angular/material/core';
import {AdminMenuComponent} from './admin-menu/admin-menu.component';
import {RouterModule} from '@angular/router';
import {PopupMessageComponent} from './popup-message/popup-message.component';
import {ErrorPageComponent} from './error-page/error-page.component';
import {MatCardModule} from '@angular/material/card';
import {MatListModule} from '@angular/material/list';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTableModule} from '@angular/material/table';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTabsModule} from '@angular/material/tabs';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatMenuModule} from '@angular/material/menu';
import {PaginatorComponent} from './paginator/paginator.component';
import {UserInfoComponent} from './user-info/user-info.component';
import {SnackBarComponent} from './snack-bar/snack-bar.component';
import {SimplifiedFormFieldDirective} from './simplified-form-field.directive';

@NgModule({
  declarations: [
    FieldComponent,
    EventNamePipe,
    DeviationDescriptionPipe,
    AttachmentListComponent,
    AttachmentComponent,
    SignatureComponent,
    ErrorComponent,
    LoadingDialogComponent,
    ConfirmationDialogComponent,
    ButtonBoxComponent,
    ExpandPanelComponent,
    ListComponent,
    PageContentComponent,
    PopupMessageComponent,
    SearchFieldComponent,
    SelectBoxComponent,
    AdminMenuComponent,
    ErrorPageComponent,
    PaginatorComponent,
    UserInfoComponent,
    SnackBarComponent,
    SimplifiedFormFieldDirective
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatExpansionModule,
    MatListModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatPaginatorModule,
    FormsModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatMenuModule,
    MatRippleModule,
    RouterModule
  ],
  exports: [
    FieldComponent,
    EventNamePipe,
    DeviationDescriptionPipe,
    AttachmentListComponent,
    SignatureComponent,
    ErrorComponent,
    ConfirmationDialogComponent,
    PageContentComponent,
    ListComponent,
    ExpandPanelComponent,
    ButtonBoxComponent,
    SearchFieldComponent,
    SelectBoxComponent,
    AdminMenuComponent,
    AttachmentComponent,
    PopupMessageComponent,
    PaginatorComponent,
    SnackBarComponent,
    SimplifiedFormFieldDirective,
  ],
  providers: [
    EventNamePipe
  ],
  bootstrap: []
})
export class ComponentModule {
}
